// extracted by mini-css-extract-plugin
export var alignCenter = "_6r-d";
export var bannerShown = "_6r-6";
export var buttonContent = "_6r-0";
export var cardList = "_6r-1";
export var centerContent = "_6r-2";
export var chevron = "_6r-3";
export var closePanelButton = "_6r-k";
export var conversationContextContainer = "_6r-l";
export var conversationDetailContainer = "_6r-4";
export var detailWrapper = "_6r-7";
export var dropdownButton = "_6r-e";
export var dropdownTitle = "_6r-9";
export var fullHeight = "_6r-5";
export var hidden = "_6r-a";
export var icon = "_6r-b";
export var mergeSuggestionWrapper = "_6r-m";
export var panel = "_6r-i";
export var portalButtonsWrapper = "_6r-c";
export var right = "_6r-j";
export var tableSummaryContainer = "_6r-8";
export var tableSummaryHeader = "_6r-g";
export var threeDotsButton = "_6r-f";
export var wide = "_6r-h";